webpackJsonp([56953485941700],{

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Scale = __webpack_require__(33);
	
	var _Legends = __webpack_require__(49);
	
	var _Legends2 = _interopRequireDefault(_Legends);
	
	var _AllToolsBubble = __webpack_require__(424);
	
	var _AllToolsBubble2 = _interopRequireDefault(_AllToolsBubble);
	
	var _allToolsUsage = __webpack_require__(747);
	
	var _allToolsUsage2 = _interopRequireDefault(_allToolsUsage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var domain = [0, 25, 50, 75, 100];
	
	var colorScale = (0, _d3Scale.scaleLinear)().domain(domain).range(['#dedfec', '#b3b5e6', '#8b8de8', '#9063e8', '#b741d3']);
	
	var legends = domain.map(function (key) {
	    return {
	        label: key + '%',
	        color: colorScale(key)
	    };
	});
	
	var JavascriptLandscapeBlock = function JavascriptLandscapeBlock() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'block block--chart' },
	        _react2.default.createElement(
	            'h3',
	            { className: 'block__title' },
	            '2017 Javascript Landscape'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'block__description' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Which tools are used with the most satisfaction?'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'block__contents' },
	            _react2.default.createElement(
	                'div',
	                { className: 'block__contents__inner' },
	                _react2.default.createElement(_Legends2.default, { legends: legends, modifier: 'horizontal' }),
	                _react2.default.createElement(_AllToolsBubble2.default, { data: _allToolsUsage2.default.allToolsUsage, colorScale: colorScale })
	            )
	        )
	    );
	};
	
	exports.default = JavascriptLandscapeBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _circlePacking = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllToolsBubble = function AllToolsBubble(_ref) {
	    var data = _ref.data,
	        colorScale = _ref.colorScale;
	    return _react2.default.createElement(
	        'div',
	        { className: 'chart-wrapper', style: { height: 800 } },
	        _react2.default.createElement(_circlePacking.ResponsiveBubbleHtml, {
	            identity: 'key',
	            tile: 'squarify',
	            value: 'doc_count',
	            leavesOnly: true,
	            innerPadding: 2,
	            labelColor: 'inherit:darker(5)',
	            labelSkipRadius: 24,
	            colorBy: function colorBy(d) {
	                return colorScale(d.percentage);
	            },
	            root: {
	                key: 'root',
	                children: data
	            }
	        })
	    );
	};
	
	AllToolsBubble.propTypes = {
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        key: _propTypes2.default.string.isRequired,
	        doc_count: _propTypes2.default.number.isRequired,
	        percentage: _propTypes2.default.number.isRequired
	    })).isRequired,
	    colorScale: _propTypes2.default.func.isRequired
	};
	
	exports.default = AllToolsBubble;
	module.exports = exports['default'];

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

	module.exports = {"allToolsUsage":[{"doc_count":1715,"key":"Backbone","percentage":7},{"doc_count":3381,"key":"PhoneGap/Cordova","percentage":14},{"doc_count":16811,"key":"Plain CSS","percentage":71},{"doc_count":1225,"key":"Elm","percentage":5},{"doc_count":78,"key":"Falcor","percentage":0},{"doc_count":4973,"key":"Grunt","percentage":21},{"doc_count":348,"key":"Aurelia","percentage":1},{"doc_count":17879,"key":"SASS/SCSS","percentage":75},{"doc_count":521,"key":"Relay/Relay Modern","percentage":2},{"doc_count":4262,"key":"Foundation","percentage":18},{"doc_count":1260,"key":"Apollo","percentage":5},{"doc_count":2794,"key":"GraphQL","percentage":12},{"doc_count":1176,"key":"Ava","percentage":5},{"doc_count":11175,"key":"Gulp","percentage":47},{"doc_count":12637,"key":"\"Plain\" JavaScript (ES5)","percentage":53},{"doc_count":1117,"key":"Ember","percentage":5},{"doc_count":2458,"key":"Ionic","percentage":10},{"doc_count":7364,"key":"LESS","percentage":31},{"doc_count":630,"key":"Sails","percentage":3},{"doc_count":2034,"key":"Rollup","percentage":9},{"doc_count":459,"key":"Loopback","percentage":2},{"doc_count":20596,"key":"ES6","percentage":87},{"doc_count":21369,"key":"NPM","percentage":90},{"doc_count":131,"key":"Reason","percentage":1},{"doc_count":4707,"key":"Angular","percentage":20},{"doc_count":2356,"key":"Stylus","percentage":10},{"doc_count":7968,"key":"TypeScript","percentage":34},{"doc_count":20615,"key":"REST API","percentage":87},{"doc_count":6485,"key":"CSS-in-JS","percentage":27},{"doc_count":309,"key":"Keystone","percentage":1},{"doc_count":533,"key":"ClojureScript","percentage":2},{"doc_count":9236,"key":"Jasmine","percentage":39},{"doc_count":4945,"key":"Electron","percentage":21},{"doc_count":14216,"key":"Bootstrap","percentage":60},{"doc_count":2198,"key":"Koa","percentage":9},{"doc_count":1142,"key":"MobX","percentage":5},{"doc_count":4449,"key":"Angular 2","percentage":19},{"doc_count":5857,"key":"Jest","percentage":25},{"doc_count":7933,"key":"Native Apps","percentage":33},{"doc_count":5519,"key":"Firebase","percentage":23},{"doc_count":14541,"key":"Express","percentage":61},{"doc_count":1515,"key":"Tape","percentage":6},{"doc_count":4580,"key":"Enzyme","percentage":19},{"doc_count":5221,"key":"Browserify","percentage":22},{"doc_count":1625,"key":"Meteor","percentage":7},{"doc_count":10725,"key":"Redux","percentage":45},{"doc_count":4647,"key":"Vue","percentage":20},{"doc_count":503,"key":"NativeScript","percentage":2},{"doc_count":1198,"key":"Polymer","percentage":5},{"doc_count":10717,"key":"Mocha","percentage":45},{"doc_count":13669,"key":"React","percentage":58},{"doc_count":447,"key":"FeathersJS","percentage":2},{"doc_count":2389,"key":"Flow","percentage":10},{"doc_count":1567,"key":"Hapi","percentage":7},{"doc_count":9493,"key":"No Front-End Framework","percentage":40},{"doc_count":4760,"key":"React Native","percentage":20},{"doc_count":16485,"key":"Webpack","percentage":70}]}

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(11);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TextBlock = __webpack_require__(25);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _Newsletter = __webpack_require__(93);
	
	var _Newsletter2 = _interopRequireDefault(_Newsletter);
	
	var _JavascriptLandscapeBlock = __webpack_require__(417);
	
	var _JavascriptLandscapeBlock2 = _interopRequireDefault(_JavascriptLandscapeBlock);
	
	var _getPageTitle = __webpack_require__(19);
	
	var _getPageTitle2 = _interopRequireDefault(_getPageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var intro = '\nA few years back, a JavaScript survey would\'ve been a simple matter. Question 1: are you using jQuery? Question 2: any comments? Boom, done! \n\nBut as we all know, things have changed. The JavaScript ecosystem is richer than ever, and even the most experienced developer can start to hesitate when considering the multitude of options available at every stage. \n\nThis is where this survey comes in: we asked over a hundred questions to more than 28,000 developers all over the world, covering topics going from front-end libraries all the way to back-end frameworks.\n\nWe believe the result is the most complete picture of the state of JavaScript currently available, and we\'re excited to share it with you!\n\nP.S. if all this data ever feels overwhelming, I\'m sure you\'ll find a way to <em>console</em> yourself\u2026\n';
	
	var Introduction = function Introduction() {
	    return _react2.default.createElement(
	        _reactDocumentTitle2.default,
	        { title: (0, _getPageTitle2.default)('Introduction') },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_TextBlock2.default, { text: intro })
	        )
	    );
	};
	
	exports.default = Introduction;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2017-introduction-js-55dfb59c0545b276fe0c.js